import { escapeTemplateText } from '@cli-utils/text.js'
import { escapeJsx } from '@cli-utils/text.js'
import { renderBuildSortableHeaderButtonJsxActionButtonsTemplate } from '@next-adapter/templates/renderers/generators/sortable-header/build-sortable-header-button-jsx.js'

export function buildSortableHeaderButtonJsx(
  headerText: string,
  options: { className?: string } = {}
): string {
  const className = options.className ?? 'w-full'

  return renderBuildSortableHeaderButtonJsxActionButtonsTemplate({
    className: className,
    escapeTemplateText: escapeTemplateText(headerText),
    escapeJsx: escapeJsx(headerText)
  })
}
